const BACKGROUND_COLORS = ['bg-default-sky', 'bg-default-yellow', 'bg-default-orange'] as const;

export function getAvatarBackgroundColorClass(letter: string): string {
  // Convert letter to uppercase and get first character
  const char = letter.trim().toUpperCase().charAt(0);

  // Simple hash function: get character code and mod by array length
  const colorIndex = char.charCodeAt(0) % BACKGROUND_COLORS.length;

  return BACKGROUND_COLORS[colorIndex];
}
